import React from 'react';
import { FileText, Map, Users, Zap, Shield } from 'lucide-react';
import { deliverables } from '../data/mock';

const iconMap = {
  0: <FileText size={24} className="text-[var(--gold-primary)]" />,
  1: <Map size={24} className="text-[var(--gold-primary)]" />,
  2: <Users size={24} className="text-[var(--gold-primary)]" />,
  3: <Zap size={24} className="text-[var(--gold-primary)]" />,
  4: <Shield size={24} className="text-[var(--gold-primary)]" />,
  5: <Shield size={24} className="text-[var(--gold-primary)]" />,
};

const DeliverablesSection = () => {
  return (
    <section id="deliverables" className="section-padding bg-[var(--bg-secondary)]">
      <div className="container px-4 sm:px-10">
        {/* Section Header */}
        <div className="section-title">
          <p className="eyebrow-gold uppercase tracking-widest mb-4">
            What You Receive
          </p>
          <h2 className="heading-1">Charter Deliverables</h2>
          <p className="body-regular mt-4">
            Comprehensive, documented outputs designed for clarity and action.
          </p>
        </div>
        
        {/* Deliverables Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {deliverables.map((item, index) => (
            <div key={index} className="deliverable-item hover-lift">
              <div className="mb-4">
                {iconMap[index]}
              </div>
              <h3 className="heading-3 mb-3">{item.name}</h3>
              <p className="body-small text-[var(--text-secondary)]">
                {item.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://rzp.io/rzp/YftyTmw"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold"
          >
            Book Complete Family Protection Charter
          </a>
        </div>
      </div>
    </section>
  );
};

export default DeliverablesSection;
